import React, { useState, useEffect, useRef } from "react";
import contactemail from "../../../assets/user/images/sms1.svg";
import contactcall from "../../../assets/user/images/call-calling.svg";
import contactlocation from "../../../assets/user/images/location1.svg";
import googlemapIcon from "../../../assets/provider/images/Google_Map.svg";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { routes } from "../../../utlis/user/routes.utlis";
import { api } from "../../../utlis/user/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import InputMask from "react-input-mask";
import { GeolocationApiKey } from "../../../utlis/common.utlis";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
    address: null,
  });

  let userData = JSON.parse(localStorage.getItem("careexchange"));

  const initialValues = {
    name: userData.fullname ?? "",
    phone: userData.mobile ?? "",
    email: userData.email ?? "",
    zipcode: "",
    address: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required!"),
    phone: Yup.string()
      .min(14, "Phone is invalid")
      .required("Mobile is required!"),
    email: Yup.string().email().required("Email address is required!"),
    zipcode: Yup.string()
      .min(5, "Zipcode is invalid")
      .max(6, "Zipcode is invalid")
      .required("Zipcode is required!"),
    address: Yup.string().required("Address is required!"),
    message: Yup.string().required("Message is required!"),
  });

  const sendContact = async (formvalue) => {
    setLoading(true);
    const form = JSON.stringify({
      name: formvalue.name,
      phone: formvalue.phone,
      email: formvalue.email,
      zipcode: formvalue.zipcode,
      address: formvalue.address,
      message: formvalue.message,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.sendContactUs,
      form
    );
    if (response.data.status) {
      setLocation({
        lat: null,
        lng: null,
        address: null,
      });
      toast.success(response.data.message);
      navigate(routes.dashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getContantDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all posted job => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data.contactData);
    } else setDetails();
    setLoading(false);
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GeolocationApiKey,
    libraries: ["places"],
  });

  const handlePlaceChange = (setFieldValue) => {
    let [address] = inputRef.current.getPlaces();
    setLocation({
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      address: address.formatted_address,
    });
    setFieldValue("address", address.formatted_address);
  };

  useEffect(() => {
    getContantDetails(api.contactUsDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="contact-page-section">
      <div className="container">
        <div className="contact-page-card">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-page-info">
                <h3>Our Contact Information </h3>

                <div className="contact-page-info-list">
                  <div className="contact-info-card">
                    <div className="contact-info-icon">
                      <img src={contactemail} />
                    </div>
                    <div className="contact-info-text">
                      <h2>Email Address</h2>
                      <p>{details?.email ?? "NA"}</p>
                    </div>
                  </div>

                  {/* <div className="contact-info-card">
                    <div className="contact-info-icon">
                      <img src={contactcall} />
                    </div>
                    <div className="contact-info-text">
                      <h2>Phone Number</h2>
                      <p>{details?.phone ?? "NA"}</p>
                    </div>
                  </div> */}

                  <div className="contact-info-card">
                    <div className="contact-info-icon">
                      <img src={contactlocation} />
                    </div>
                    <div className="contact-info-text">
                      <h2>Office Address</h2>
                      <p>{details?.Address ?? "NA"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-page-form">
                <h3>Contact Us</h3>
                <Formik
                  initialValues={initialValues}
                  validateOnChange={true}
                  validationSchema={validationSchema}
                  onSubmit={sendContact}
                >
                  {({ values, setFieldValue }) => (
                    <Form id="send-contact">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Your Name</h4>
                            <Field
                              type="text"
                              className="form-control todo-list-input"
                              name="name"
                              placeholder="Enter Name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Email Address</h4>
                            <Field
                              type="email"
                              className="form-control"
                              name="email"
                              placeholder="Enter Email"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Phone</h4>
                            <Field name="phone">
                              {({ field }) => (
                                <InputMask
                                  {...field}
                                  mask="(999) 999-9999"
                                  className="form-control"
                                  maskChar=""
                                  onChange={(e) => {
                                    setFieldValue(field.name, e.target.value);
                                  }}
                                  placeholder="Enter phone"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="phone"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Zip Code</h4>
                            <Field
                              type="number"
                              className="form-control"
                              name="zipcode"
                              placeholder="Zip Code"
                            />
                            <ErrorMessage
                              name="zipcode"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12 mb-2">
                          <div className="form-group search-form-group mb-1">
                            <h4>Address</h4>
                            {isLoaded && (
                              <StandaloneSearchBox
                                onLoad={(ref) => (inputRef.current = ref)}
                                onPlacesChanged={() =>
                                  handlePlaceChange(setFieldValue)
                                }
                              >
                                <input
                                  className="form-control"
                                  placeholder="Enter Address"
                                  defaultValue={location.address}
                                />
                              </StandaloneSearchBox>
                            )}
                            <span className="form-group-icon">
                              <img src={googlemapIcon} />
                            </span>
                          </div>
                          <ErrorMessage
                            name="address"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Message</h4>
                            <Field
                              type="text"
                              as="textarea"
                              className="form-control"
                              name="message"
                              placeholder="Enter Your Message"
                            />
                            <ErrorMessage
                              name="message"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <button
                              className="btn-bl"
                              onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("send-contact").reset();
                                setLocation({
                                  lat: null,
                                  lng: null,
                                  address: null,
                                });
                              }}
                            >
                              {" "}
                              Clear All
                            </button>
                            <button className="btn-gr mx-2" type="submit">
                              {" "}
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
